module.exports = __webpack_public_path__ + "static/media/CERTIFICATE-SEKOLAH-BULANAN-1.faf5f3b7.png";